/* eslint-disable camelcase */
import { call, put, takeLatest, select } from 'redux-saga/effects'
import axiosApi from '../../views/client/axiosClient'
import { handleRequest, transfersFromCached } from '../../lib/common'

import { FormFiels } from '../Order/constants'
import marketingOrderConstants from './constants'
import * as orderActions from './actions'

const getOrderState = state => state.order;

function* loadThuoc({payload, onSuccess}) {
  try {
    const request = axiosApi().post(
      marketingOrderConstants.LOAD_THUOC_INFO_API,
      payload
    )

    yield put(orderActions.setIsLoading(true));
    const response = yield call(handleRequest, request);
    const { code, message, data } = response
    if (code != 200) {
      return yield put(orderActions.setWarning(message))
    }
    if (!data) {
      const warningMsg = 'Thuốc đang hết hàng trong kho, hãy chọn thuốc khác'
      return yield put(orderActions.setWarning(warningMsg))
    }

    yield put(orderActions.setThuoc(data));
    yield put(orderActions.setItem(data));
    yield call(onSuccess, data)
  } catch (error) {
    yield put(orderActions.setWarning(error.toString()))
  } finally {
    yield put(orderActions.setIsLoading(false));
  }
}

function* loadThuocs({payload, onSuccess}) {
  try {
    const request = axiosApi().post(
      marketingOrderConstants.LOAD_THUOCS_API,
      payload
    )
    const response = yield call(handleRequest, request);
    const { data: { records } } = response
    yield put(orderActions.setThuocs(records));
    if (onSuccess) {
      yield call(onSuccess, records)
    }
  } catch (error) {
    yield put(orderActions.setError(error.toString()))
  }
}

function* loadOrderDetails({payload, callback}) {
  try {
    const request = axiosApi().post(
      marketingOrderConstants.LOAD_ORDER_DETAILS_API,
      {
        order_id: payload.orderId,
        mode: payload.mode
      }
    )
    yield put(orderActions.setIsLoading(true));
    const response = yield call(handleRequest, request);
    if (!response) {
      yield put(orderActions.setError("Lỗi lấy thông tin đơn hàng"))
    }
    const { code, message, data } = response
    if (code != 200) {
      yield put(orderActions.setError(message))
      if (callback && callback.onError) {
        yield call(callback.onError, message)
      }
      return
    }
    yield put(orderActions.setOrderInfor(data));
    if (data.items) {
      const items = data.items.map((item) => {
        return {
          id: item.Id,
          product_id: item.product_id,
          ten: item.ten_hang,
          gia_ban: item.gia_ban || 0,
          dvt: item.dvt,
          so_luong: item.so_luong || 0,
          chiet_khau: item.chiet_khau || 0,
          diem: item.diem,
          thanh_tien: item.thanh_tien,
          sku: item.sku,
          is_km: item.is_km,
          gia_ban_origin: item.gia_ban_origin,
        }
      })

      yield put(orderActions.setItems(items))
      if (callback && callback.onSuccess) {
        yield call(callback.onSuccess, data)
      }
    }
  } catch (error) {
    yield put(orderActions.setError(error.toString()))
  } finally {
    yield put(orderActions.setIsLoading(false));
  }
}

function* loadCustomers({payload, onSuccess}) {
  try {
    const request = axiosApi().post(
      marketingOrderConstants.LOAD_CUSTOMERS_API,
      payload
    )
    const { records } = yield call(handleRequest, request)
    const items = transfersFromCached(records)
    yield call(onSuccess, items)
  } catch (error) {
    yield put(orderActions.setError(error.toString()))
  }
}

function* loadOrderHistory({payload, callback}) {
  try {
    const request = axiosApi().post(
      marketingOrderConstants.LOAD_ORDER_HISTORY_API,
      payload
    )
    yield put(orderActions.setIsLoading(true));
    const { code, records, message } = yield call(handleRequest, request);
    if (code != 200) {
      return yield put(orderActions.setError(message))
    }
    if (typeof callback === 'function') {
      yield call(callback, records)
    }
  } catch (error) {
    yield put(orderActions.setError(error.toString()))
  } finally {
    yield put(orderActions.setIsLoading(false));
  }
}
function handleFileRequest(request) {
  return request
    .then(function (response) {
      return {
        data: response.data
      };
    })
    .catch((error) => { throw error })
}
function* loadOrderExport() {
  try {
    const order = yield select(getOrderState);
    const url = `${marketingOrderConstants.LOAD_ORDER_EXPORT_API}/${order.formData.order_id}/${order.formData.store_id}`;
    const request = axiosApi().get(
      url,
      {
        responseType: 'blob'
      }
    );
    yield put(orderActions.setIsLoading(true));
    const { data } = yield call(handleFileRequest, request);
    yield put(orderActions.SetOrderExport(data));
  } catch (error) {
    yield put(orderActions.setError(error.toString()))
  } finally {
    yield put(orderActions.setIsLoading(false));
  }
}
// xuat ra excel
function* loadOrderExcel({payload, onSuccess}) {
  try {
    const url = `${marketingOrderConstants.LOAD_ORDER_EXCEL_API}?order=${payload.orderId}`;
    const request = axiosApi().get(
      url,
      {
        responseType: 'blob'
      }
    );
    yield put(orderActions.setIsLoading(true));

    // grab the client from our action
    const results = yield call(handleRequest, request);
    if (results.code && results.code != 200) {
      yield put(orderActions.setError(results.message))
    }
    // callback on success
    if (typeof onSuccess === 'function') {
      yield call(onSuccess, results)
    }
  } catch (error) {
    yield put(orderActions.setError(error.toString()))
  } finally {
    yield put(orderActions.setIsLoading(false));
  }
}

// huỷ bỏ đơn hàng chỉ người có quyền mới được tác động
function* cancelOrder({payload, onSuccess}) {
  try {
    const request = axiosApi().post(
      marketingOrderConstants.CANCEL_ORDER_API,
      payload
    )
    yield put(orderActions.setIsLoading(true));
    const { code, message, data } = yield call(handleRequest, request);
    if (code != 200) {
      yield put(orderActions.setError(message))
    } else {
      yield put(orderActions.setMessage(message));
      yield call(onSuccess, data)
    }
  } catch (error) {
    yield put(orderActions.setError(error.toString()))
  } finally {
    yield put(orderActions.setIsLoading(false));
  }
}

function* sendOrder({payload, onSuccess}) {
  try {
    const request = axiosApi().post(
      marketingOrderConstants.SEND_ORDER_API,
      payload
    )
    const response = yield call(handleRequest, request);
    yield call(onSuccess, response)
  } catch (error) {
    yield call(onSuccess, {code: 500, message: error.toString()})
  }
}

function* unlockOrder({payload, callback}) {
  try {
    const reqData = {
      id: payload.orderId,
      loai_hd: payload.typeOfOrder,
    }
    const request = axiosApi().post(
      marketingOrderConstants.UNLOCK_ORDER_API,
      reqData
    )

    yield put(orderActions.setIsLoading(true));
    const response = yield call(handleRequest, request)
    if (response.code !== 200) {
      yield put(orderActions.setError(response.message))
    } else {
      yield put(orderActions.setMessage(response.message))
      yield call(callback)
    }
  } catch (error) {
    yield put(orderActions.setError(error.toString()))
  } finally {
    yield put(orderActions.setIsLoading(false));
  }
}

function* saveOrder({payload, callback}) {
  try {
    const {
      items,
      orderInfor,
      typeOfOrder,
      lstCustomer
    } = payload
    const reqData = {
      id: orderInfor[FormFiels.OrderId],
      loai_hd: typeOfOrder,
      kho_xuat_id: orderInfor[FormFiels.KhoXuatId],
      ghi_chu: orderInfor[FormFiels.GhiChu],
      bo_chiet_khau: orderInfor[FormFiels.BoChietKhau],
      ngay_lap: orderInfor[FormFiels.NgayLap],
      ngay_giao: orderInfor[FormFiels.NgayGiao],
      xuat_hoa_don: orderInfor[FormFiels.XuatHoaDon],
      khach_hangs: lstCustomer,
      nhan_vien_id: orderInfor[FormFiels.NhanVienId],
      kho_nhap_id: orderInfor[FormFiels.KhoNhapId],
      items: items,
    }
    const request = axiosApi().post(
      marketingOrderConstants.SAVE_ORDER_API,
      reqData
    )

    yield put(orderActions.setIsLoading(true));
    const response = yield call(handleRequest, request)
    if (response.code !== 200) {
      yield put(orderActions.setError(response.message))
    } else {
      const {data} = response
      yield put(orderActions.setMessage(response.message))
      yield call(callback, data)
    }
  } catch (error) {
    yield put(orderActions.setError(error.toString()))
  } finally {
    yield put(orderActions.setIsLoading(false));
  }
}

function* marketingOrderWatcher() {
  yield [
    yield takeLatest(marketingOrderConstants.LOAD_ORDER_DETAILS, loadOrderDetails),
    yield takeLatest(marketingOrderConstants.LOAD_CUSTOMERS, loadCustomers),
    yield takeLatest(marketingOrderConstants.LOAD_THUOCS, loadThuocs),
    yield takeLatest(marketingOrderConstants.LOAD_THUOC_INFO, loadThuoc),
    yield takeLatest(marketingOrderConstants.LOAD_ORDER_HISTORY, loadOrderHistory),
    yield takeLatest(marketingOrderConstants.LOAD_ORDER_EXPORT, loadOrderExport),
    yield takeLatest(marketingOrderConstants.LOAD_ORDER_EXCEL, loadOrderExcel),
    yield takeLatest(marketingOrderConstants.SAVE_ORDER, saveOrder),
    yield takeLatest(marketingOrderConstants.CANCEL_ORDER, cancelOrder),
    yield takeLatest(marketingOrderConstants.SEND_ORDER, sendOrder),
    yield takeLatest(marketingOrderConstants.UNLOCK_ORDER, unlockOrder),
  ]
}

export default marketingOrderWatcher



// WEBPACK FOOTER //
// ./src/views/MarketingOrder/sagas.js